import { render, staticRenderFns } from "./ContactInfoEdit.vue?vue&type=template&id=6a1e8019&scoped=true"
import script from "./ContactInfoEdit.vue?vue&type=script&lang=js"
export * from "./ContactInfoEdit.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/review_edit.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e8019",
  null
  
)

export default component.exports